import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { getUrlCourtCode } from 'helper/Court';
// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import Players from 'views/pages/players/players';
import Courts from 'views/pages/courts/courts';
import AddCourts from 'views/pages/courts/addCourt';
import PackageList from 'views/pages/package/packageList';
import AddPackage from 'views/pages/package/addPackage';
import Orders from 'views/pages/orders/orders';
import Coupon from 'views/pages/coupons/coupons';
import AddCoupon from 'views/pages/coupons/addCoupon';
import Admins from 'views/pages/admins/admins';
import PlayerDetail from 'views/pages/players/playerDetail';
import AddOns from 'views/pages/addon/addons';
import AddAddOn from 'views/pages/addon/addAddon';
import Vouchers from 'views/pages/vouchers/vouchers';
import AddVoucher from 'views/pages/vouchers/addVoucher';
import AddClass from 'views/pages/classes/addClass';
import Counters from 'views/pages/settings/counters/counters';
import AddCounter from 'views/pages/settings/counters/addCounter';
import AddAdmin from 'views/pages/admins/addAdmin';
import Categories from 'views/pages/settings/categories/categories';
// import AddCategories from 'views/pages/settings/categories/addCategories';
import QRReader from 'views/pages/orders/qrReader';
import OrderDetail from 'views/pages/orders/orderDetail';
import CreateOrder from 'views/pages/orders/createOrder';
import Payments from 'views/pages/payment/payments';
import SaleReport from 'views/pages/report/SaleReport/SaleReport';
import { reactLocalStorage } from 'reactjs-localstorage';
import CourtTypes from 'views/pages/courts/court-types/courtType';
import AddCourtTypes from 'views/pages/courts/court-types/addCourtType';
import Terms from 'views/pages/settings/terms/terms';
import AddTerm from 'views/pages/settings/terms/addTerm';
import Tournaments from 'views/pages/tournament/tournaments';
import AddTournament from 'views/pages/tournament/addTournament';
import EditProfile from 'views/pages/settingProfile/EditProfile';
import Merchants from 'views/pages/merchant/merchants';
import Merchant from 'views/pages/merchant/merchant';

const Coaches = Loadable(lazy(() => import('views/pages/coaches/coaches')));
// const AddCoaches = Loadable(lazy(() => import('views/pages/coaches/addCoaches')));
const Classes = Loadable(lazy(() => import('views/pages/classes/classes')));

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/pages/dashboard/Dashboard')));

// ==============================|| MAIN ROUTING ||============================== //

const isLoggedIn = reactLocalStorage.get('user_token');

const AdminRoutes = {
    path: '/',
    element: isLoggedIn ? <MainLayout /> : <Navigate to="/login" replace/>,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: `/${getUrlCourtCode()}/dashboard`,
            children: [
                {
                    path: '',
                    element: <DashboardDefault />
                }
            ]
        },
        {
            path: `/${getUrlCourtCode()}/courts`,
            element: <Courts />
        },
        {
            path: `/${getUrlCourtCode()}/courts/add`,
            element: <AddCourts />
        },
        {
            path: `/${getUrlCourtCode()}/courts/edit/:courtsId`,
            element: <AddCourts />
        },
        {
            path: 'court-types',
            element: <CourtTypes />
        },
        {
            path: 'court-types/add',
            element: <AddCourtTypes />
        },
        {
            path: 'court-types/edit/:courtTypeId',
            element: <AddCourtTypes />
        },
        {
            path: `/${getUrlCourtCode()}/orders`,
            element: <Orders />
        },
        {
            path: `/${getUrlCourtCode()}/orders/create-order`,
            element: <CreateOrder />
        },
        {
            path: `/${getUrlCourtCode()}/orders/:id`,
            element: <OrderDetail />
        },
        {
            path: `/${getUrlCourtCode()}/users`,
            element: <Players />
        },
        {
            path: `/${getUrlCourtCode()}/users/detail/:playerId`,
            element: <PlayerDetail />
        },
        {
            path: `/${getUrlCourtCode()}/coaches`,
            element: <Coaches />
        },
        {
            path: `/${getUrlCourtCode()}/classes`,
            element: <Classes />
        },
        {
            path: `/${getUrlCourtCode()}/classes/add`,
            element: <AddClass />
        },
        {
            path: `/${getUrlCourtCode()}/classes/edit/:classId`,
            element: <AddClass />
        },
        {
            path: `/${getUrlCourtCode()}/payments`,
            element: <Payments />
        },
        {
            path: `/${getUrlCourtCode()}/admins`,
            element: <Admins />
        },
        {
            path: `/${getUrlCourtCode()}/admins/add`,
            element: <AddAdmin />
        },
        {
            path: `/${getUrlCourtCode()}/admins/edit/:adminId`,
            element: <AddAdmin />
        },
        {
            path: `/${getUrlCourtCode()}/packages`,
            element: <PackageList />
        },
        {
            path: `/${getUrlCourtCode()}/packages/add`,
            element: <AddPackage />
        },
        {
            path: `/${getUrlCourtCode()}/packages/edit/:packageId`,
            element: <AddPackage />
        },
        {
            path: `/${getUrlCourtCode()}/coupons`,
            element: <Coupon />
        },
        {
            path: `/${getUrlCourtCode()}/coupons/add`,
            element: <AddCoupon />
        },
        {
            path: `/${getUrlCourtCode()}/coupons/edit/:couponId`,
            element: <AddCoupon />
        },
        {
            path: `/${getUrlCourtCode()}/addon`,
            element: <AddOns />
        },
        {
            path: `/${getUrlCourtCode()}/addon/add`,
            element: <AddAddOn />
        },
        {
            path: `/${getUrlCourtCode()}/addon/edit/:addonId`,
            element: <AddAddOn />
        },
        {
            path: `/${getUrlCourtCode()}/vouchers`,
            element: <Vouchers />
        },
        {
            path: `/${getUrlCourtCode()}/vouchers/add`,
            element: <AddVoucher />
        },
        {
            path: 'counter',
            element: <Counters />
        },
        {
            path: 'counter/add',
            element: <AddCounter />
        },
        {
            path: 'counter/edit/:counterId',
            element: <AddCounter />
        },
        {
            path: 'categories',
            element: <Categories />
        },
        {
            path: `/${getUrlCourtCode()}/match-tournament`,
            element: <Tournaments />
        },
        {
            path: `/${getUrlCourtCode()}/match-tournament/tournament/add`,
            element: <AddTournament />
        },
        {
            path: `/${getUrlCourtCode()}/match-tournament/tournament/edit/:id`,
            element: <AddTournament />
        },
        {
            path: 'term-and-conditions',
            element: <Terms />
        },
        {
            path: 'term-and-condition/add',
            element: <AddTerm />
        },
        {
            path: 'term-and-condition/edit/:Id',
            element: <AddTerm />
        },
        {
            path: 'qr-read',
            element: <QRReader />
        },
        {
            path: 'sales-report',
            element: <SaleReport />
        },
        {
            path: `/${getUrlCourtCode()}/setting-profile/:adminId`,
            element: <EditProfile />
        },
        {
            path: `/${getUrlCourtCode()}/merchants`,
            element: <Merchants />
        },
        {
            path: `/${getUrlCourtCode()}/merchants/add`,
            element: <Merchant />
        },
        {
            path: `/${getUrlCourtCode()}/merchants/edit/:id`,
            element: <Merchant />
        },
        {
            path: `/${getUrlCourtCode()}/merchants/admins/add`,
            element: <AddAdmin />
        },
        {
            path: `/${getUrlCourtCode()}/merchants/admins/edit/:adminId`,
            element: <AddAdmin />
        }
        
    ]
};

export default AdminRoutes;